import { fabric } from 'fabric';
import Store from '@/store';

const TYPE = 'labeled-object-base';

enum Parts {
  Container,
  Labels,
}

const LabeledObjectBase = fabric.util.createClass(fabric.Group, {
  type: TYPE,
  scaling: false,
  includeDefaultValues: false,
  textStyle: '',
  perPixelTargetFind: true,

  initialize: function (objects: fabric.Object[], options: fabric.RectOptions) {
    this.callSuper('initialize', objects, options);

    this.on('scaling', () => {
      this.resizeLabel();
    });
    this.on('modified', () => {
      this.resizeLabel();
    });
  },

  set: function <K extends keyof fabric.Group>(...params: [K, fabric.Group[K]] | [Record<K, fabric.Group[K]>]) {
    // options object
    if (params.length === 1) {
      const options = params[0];
      for (const prop in options) {
        this._setRectOptions(prop, options[prop]);
        switch (prop) {
          case 'opacity':
          case 'fill':
          case 'strokeWidth':
          case 'strokeDashArray':
            break;
          default:
            this.callSuper('set', prop, options[prop]);
        }
      }
    }
    // key/value pair
    else if (params.length === 2) {
      const prop = params[0];
      const value = params[1];
      this._setRectOptions(prop, value);
      switch (prop) {
        case 'opacity':
        case 'fill':
        case 'strokeWidth':
        case 'strokeDashArray':
          break;
        default:
          this.callSuper('set', prop, value);
      }
    }
  },

  get: function <K extends keyof fabric.Group>(key: K): fabric.Group[K] {
    switch (key) {
      case 'fill':
      case 'opacity':
      case 'strokeWidth':
      case 'strokeDashArray':
      case 'stroke':
        return this._objects[Parts.Container].get(key);
      case 'fontFamily':
        return this._objects[Parts.Labels].get(key);
      default:
        return this.callSuper('get', key);
    }
  },

  _setRectOptions<K extends keyof fabric.LabeledObjectBase>(key: K, value: fabric.LabeledObjectBase[K]) {
    switch (key) {
      case 'width':
      case 'height':
        this._objects[Parts.Container].set(key, value);
        break;
      case 'fill':
        this.fill = value;
        this._objects[Parts.Container].set(key, value);
        break;
      case 'opacity':
        this._objects[Parts.Container].set(key, value);
        break;
      case 'stroke':
        this.stroke = value;
        this._objects[Parts.Container].set(key, value);
        break;
      case 'strokeWidth': {
        this.strokeWidth = value;
        const c_width = this._objects[Parts.Container].get('width');
        const c_height = this._objects[Parts.Container].get('height');
        const c_strokeWidth = this._objects[Parts.Container].get('strokeWidth');
        const c_strokeWidthDiff = (c_strokeWidth - value);

        const zoom = Store.state.towerCanvasState.zoomLevel;
        const s = this.getTotalObjectScaling();

        const l_width = this._objects[Parts.Labels].get('width');
        const l_newWidth = (((l_width * (s.scaleX / zoom)) + c_strokeWidthDiff)/ (s.scaleX / zoom));
        this._objects[Parts.Labels].set('width', l_newWidth);

        const c_newWidth = (((c_width * (s.scaleX / zoom)) + c_strokeWidthDiff)/ (s.scaleX / zoom));
        const c_newHeight = (((c_height * (s.scaleY / zoom)) + c_strokeWidthDiff)/ (s.scaleY / zoom));

        this._objects[Parts.Container].set('width', c_newWidth);
        this._objects[Parts.Container].set('height', c_newHeight);
        this._objects[Parts.Container].set('strokeWidth', value);
        this.set('width', c_newWidth);
        this.set('height', c_newHeight);
        break;
      }
      case 'strokeDashArray':
        this.strokeDashArray = value;
        this._objects[Parts.Container].set(key, value);
        break;
      case 'fontSize':
      case 'fontFamily':
        this._objects[Parts.Labels].set(key, value);
        break;
      case 'textColor':
        if (this._objects[Parts.Labels] instanceof fabric.Group) {
          this._objects[Parts.Labels].forEachObject((textObj) => {
            textObj.set('fill', value);
          });
        } else {
          this._objects[Parts.Labels].set('fill', value);
        }
        break;
        
    }
  },

  resizeLabel() {
    const zoom = Store.state.towerCanvasState.zoomLevel;
    const s = this.getTotalObjectScaling();

    this._objects[Parts.Labels].set('scaleX', Math.abs((this.width * zoom) / (this.width * s.scaleX)));
    this._objects[Parts.Labels].set('scaleY', Math.abs((this.height * zoom) / (this.height * s.scaleY)));
    this._objects[Parts.Labels].set('width', Math.abs((this.width * s.scaleX) / zoom));
  },

  toObject: function (propsToInclude?: string[]) {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      textStyle: this.textStyle,
      ...propsToInclude,
    });
  },  

});

export default LabeledObjectBase;
